import styled from "@emotion/styled"

export default styled.p`
  font-family: Open Sans;
  margin-bottom: 1rem;
  color: ${props => props.theme.color.text.high};
`
